module.exports = __webpack_public_path__ + "static/avatar_lan-33a32cfe1aa34a914b81f0c104998b41.png";